import { useState } from 'react'
import { api } from '../lib/api'

export default function Onboarding({ user, onComplete }) {
  const [form, setForm] = useState({
    name: '',
    owner_phone: '',
    google_review_link: '',
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  function handleChange(e) {
    let value = e.target.value
    if (e.target.name === 'owner_phone') {
      value = value.replace(/\D/g, '').slice(0, 10)
    }
    setForm(prev => ({ ...prev, [e.target.name]: value }))
  }

  async function handleSubmit(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      let phone = form.owner_phone.replace(/\D/g, '').slice(0, 10)
      phone = '+1' + phone
      const business = await api.createBusiness({ ...form, user_id: user.id, owner_phone: phone })
      onComplete(business)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Set up your business</h2>
        <p style={styles.sub}>Takes less than 2 minutes. You can change these anytime.</p>

        <form onSubmit={handleSubmit} style={styles.form}>
          <label style={styles.label}>Business Name</label>
          <input
            style={styles.input}
            name="name"
            placeholder="Mike's Plumbing"
            value={form.name}
            onChange={handleChange}
            required
          />

          <label style={styles.label}>Your Mobile Number</label>
          <input
            style={styles.input}
            name="owner_phone"
            placeholder="3215550000"
            value={form.owner_phone}
            onChange={handleChange}
            required
            maxLength={10}
            inputMode="numeric"
          />
          <p style={styles.hint}>We'll text you when a customer doesn't confirm.</p>

          <label style={styles.label}>Google Review Link</label>
          <input
            style={styles.input}
            name="google_review_link"
            placeholder="https://g.page/r/..."
            value={form.google_review_link}
            onChange={handleChange}
            required
          />
          <p style={styles.hint}>Find this in your Google Business Profile.</p>

          {error && <p style={styles.error}>{error}</p>}

          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Setting up...' : 'Start using JobConfirmed ->'}
          </button>
        </form>
      </div>
    </div>
  )
}

const styles = {
  container: {
    minHeight: '100vh',
    background: '#0a0a0f',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'DM Sans', sans-serif",
    padding: 20,
  },
  card: {
    background: '#13131a',
    border: '1px solid #1e1e2e',
    borderRadius: 16,
    padding: '48px 40px',
    width: '100%',
    maxWidth: 480,
  },
  title: {
    color: '#fff',
    fontSize: 24,
    fontWeight: 700,
    margin: '0 0 8px',
  },
  sub: {
    color: '#6b6b80',
    fontSize: 14,
    margin: '0 0 32px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  label: {
    color: '#a0a0b8',
    fontSize: 13,
    fontWeight: 600,
    marginTop: 8,
  },
  input: {
    background: '#1a1a24',
    border: '1px solid #2a2a3a',
    borderRadius: 8,
    padding: '12px 16px',
    color: '#fff',
    fontSize: 14,
    outline: 'none',
  },
  hint: {
    color: '#4a4a60',
    fontSize: 12,
    margin: '2px 0 0',
  },
  error: {
    color: '#ff4d4d',
    fontSize: 13,
  },
  button: {
    background: '#4f46e5',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    padding: '13px 0',
    fontSize: 15,
    fontWeight: 600,
    cursor: 'pointer',
    marginTop: 16,
  },
}
